<template>
  <div id="login" :class="isMobile?'mobile-login':'login'">
    <div class="form_control">
      <input v-model="formData.email" type="email" placeholder="请输入邮箱" class="form_input_email"/>
      <span class="tip" :hidden="tip_email"><img :src="staticUrl+'mobile/Tips.png'" alt>{{ tip_text }}</span>
    </div>
    <div class="form_control">
      <input autocomplete="off" type="tel" v-model="formData.code" placeholder="请输入验证码" class="form_input_code"/>
      <button type="button"  @click="sendCode" :class="{ none: disabled }">
        {{ sendSec>0?sendSec+'秒后再试':'获取验证码' }}
      </button>
      <span class="tip" :hidden="tip_code"><img :src="staticUrl+'mobile/Tips.png'" alt>{{ tip_text }}</span>
    </div>
    <div class="login-button"><button type="button"  @click="loginClick">登录</button></div>
    <div class="login-checkbox">
      <input type="checkbox" value="" @change="checkboxChange">我已阅读并同意
      <a href="/services" target="_blank">服务条款</a>及<a href="/privacyPolicy" target="_blank">隐私协议</a>
    </div>
    <!-- <div class="line" v-if="isMobile"></div> -->
    <!-- <div class="form_control other">
      其他账号登录：
      <br v-if="isMobile"/>
      <a @click="loginGoogle"><img :src="staticUrl+'mobile/google-big.png'" alt></a>
      <a @click="loginFacebook"><img :src="staticUrl+'mobile/facebook-big.png'" alt></a>
      <a @click="loginApple"><img :src="staticUrl+'mobile/apple-big.png'" alt></a>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      tip_text: '',
      tip_email: true,
      tip_code: true,
      disabled: false,
      isCheck: false,
      sendSec: 0,
      formData: {
        email: '',
        code: ''
      },
    }
  },
  created () {
  },
  computed: {
    ...mapGetters(['isMobile','staticUrl'])
  },
  methods: {
    ...mapActions(['ZhuziUserLogin','EmailLogin']),
    loginIn () {
      this.$router.push({ name: 'mobileLogin', query: {} })
    },
    sendCode () {
      if (this.formData.email === '') {
        this.showError('请输入邮箱，邮箱不能为空')
        return;
      }
      this.disabled = true
      if (this.sendSec > 0) {
        return;
      }
      this.sendSec = 60
      let timeId = setInterval(() => {
        this.sendSec--
        if (this.sendSec <= 0) {
          this.sendSec = 0
          this.disabled = false
          clearInterval(timeId)
        }
      }, 1000)
      this.EmailLogin({ email: this.formData.email }).then(res => {
        this.showSuccess('验证码發送成功')
      }).catch(() => {
        this.showError('验证码發送失败，请重确认邮箱是否正确！')
      })
    },
    loginClick () {
      if (this.formData.email === '') {
        this.tip_text = '请输入邮箱，邮箱不能为空！'
        this.tip_email = false
        return
      } else {
        this.tip_email = true
      }
      if (this.formData.code === '' && this.formData.code.length<4) {
        this.tip_text = '请输入验证码'
        this.tip_code = false
        return
      } else {
        this.tip_code = true
      }
      if (!this.isCheck) {
        this.showError('请确认隐私协议选项内容')
        return
      }
      this.ZhuziUserLogin({ email: this.formData.email, code: this.formData.code }).then(res => {
        res.username = this.formData.email
      }).catch(() => {
        this.showError('请重确认验证码以及邮箱是否正确！')
      })
    },
    checkboxChange (e) {
      this.isCheck = e.target.checked
    }
  }
}
</script>

<style lang="scss">
  .tip{
    padding-left: 16px;
    font-size:12px;
    font-family:SimSun;
    color:rgba(255,64,64,1);
    line-height:30px;
  }
</style>
